import React from 'react';
import PropTypes from 'prop-types';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

const VerbAccordionButton = ({ children, eventKey, callBack, as, className }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () => callBack && callBack(eventKey));
    const Component = as || 'div';
    return (
        <Component className={className} onClick={decoratedOnClick}>
            {children}
        </Component>
    );
};

VerbAccordionButton.propTypes = {
    children: PropTypes.element,
    eventKey: PropTypes.string,
    callBack: PropTypes.func,
    as: PropTypes.string,
    className: PropTypes.string
};

export default VerbAccordionButton;
